import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface ProductServiceTypeEditorViewProps {
    productServiceTypeRequest: DropdownRequest<ProductServiceTypeSummary>;
    value: number | null;
    mode: ControlMode;
    onChanged: (number: ProductServiceTypeSummary) => void;
    label?: string;
    required?: boolean;
    categoryId?: number;
}

export class ProductServiceTypeEditorView extends React.Component<ProductServiceTypeEditorViewProps, any> {
    constructor(props) {
        super(props);
    }

    render() {
        let label = this.props.label;
        if (label === undefined) {
            label = 'Product service';
        }

        return (
            <DropdownView
                required={this.props.required}
                label={label}
                disabled={this.props.mode == 'display'}
                model={this.props.value}
                onChanged={(item) => { this.props.onChanged(item) }}
                request={this.props.productServiceTypeRequest}
                keyField="id"
                textField="displayName"
                cascadeField="categoryId"
                cascadeValue={this.props.categoryId}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/products/product-service-types/parts/product-service-type-editor.view.tsx